import './main.bibliotek.scss'

import $ from 'jquery'

window.$ = $
window.jQuery = $

import 'foundation-sites'
import '@mcfse/design-system'

import { initSearch } from '@js/search.js'
import { initSite } from '@js/site.js'

document.addEventListener('DOMContentLoaded', () => {
    initSearch()
    initSite()
})
